import React from 'react';

import {ECalendarLeadDate, ECalendarType, TCalendarType} from './types';

type TCalendarContext = {
  startDate: Date | null;
  endDate: Date | null;
  calendarType: TCalendarType;
  now: Date;
  minDate: Date | null;
  maxDate: Date | null;
  leadDate: ECalendarLeadDate;
  hoveredDate: Date | null;
  setHoveredDate: (date: Date | null) => void;
};

const CalendarContext = React.createContext<TCalendarContext>({
  calendarType: ECalendarType.DATE,
  now: new Date(),
  startDate: null,
  endDate: null,
  minDate: null,
  maxDate: null,
  leadDate: ECalendarLeadDate.START,
  hoveredDate: null,
  setHoveredDate: () => {},
});

const useCalendarContext = () => {
  const values = React.useContext(CalendarContext);

  return values;
};

export {useCalendarContext, CalendarContext};
